<template>
    <div v-if="ticketData != null">
        <div class="backdrop active"></div>
        <div class="modal accept-bet active ticket-check modalTicketAnimation modal-location-top"
        style="color: #fff;"
        v-if="ticketData.errors && ticketData.errors.length">
            <div class="tcheck-header">
                <p class="tcheck-number-text">{{$t('TICKETFETCHERROR')}}</p>
                <div class="modal-close" v-on:click="toggleTicketModal">
                    <div class="icon-close icon-default" />
                </div>
            </div>
            <div class="tcheck-event tcheck-event-main">
                <div v-for="(error, index) of ticketData.errors"
                class=""
                :key="index">
                    {{error | parseTicketError}}
                </div>
            </div>
        </div>
        <div class="modal accept-bet active ticket-check modalTicketAnimation modal-location-top" ref_testcafe="ticket_modal" style="color: #fff;" v-else-if="ticketData && ticketData.data">
            <div class="tcheck-paidout" v-if="ticketData.data.payoutStatus === 'PAID' && ticketData.data.status == 'WIN'">
                <img src="../../assets/img/icon-ticket-paidout.svg">
                <p>{{$t('TICKETPAIDOUT')}}</p>
            </div>
            <div class="tcheck-header">
                <p class="tcheck-number-text">
                    {{$t('TICKETID')}}:
                    <span class="tcheck-number" ref_testcafe="ticket_code">
                        {{ticketData.data.code}}
                    </span>
                </p>
                <div class="tcheck-date-content">
                    <p class="tcheck-date">
                        {{$t('DATE')}}: {{ticketDataDateRecieved | getLocalDate}}
                    </p>
                </div>
                <div class="tcheck-date-content">
                    <p class="tcheck-date">
                        {{$t('TICKETTYPE_'+ticketType)}}
                    </p>
                </div>
                <div class="tcheck-date-content">
                    <div class="tcheck-event-status" ref_testcafe="ticket_status">
                        <div class="active" v-if="ticketData.data.status == 'ACTIVE' || ticketData.data.status == 'PREPARED'" >
                            <i class="icon-pending iconset"></i>
                        </div>
                        <div class="win" v-else-if="ticketData.data.status == 'WIN'">
                            <i class="icon-win iconset"></i>
                        </div>
                        <div class="lost" v-else-if="ticketData.data.status == 'LOST'">
                            <i class="icon-lost iconset"></i>
                        </div>
                        <div class="refund" v-else-if="ticketData.data.status == 'REFUND'">
                            <i class="icon-refund iconset"></i>
                        </div>
                        <div class="cancelled" v-else-if="ticketData.data.status == 'CANCELLED'">
                            <i class="icon-cancelled iconset"></i>
                        </div>
                        <div class="pending" v-else>
                            <i class="icon-pending iconset"></i>
                        </div>
                    </div>
                </div>
                <div class="modal-close" ref_testcafe="close_ticket" v-on:click="toggleTicketModal"><div class="icon-default icon-close" /></div>
            </div>
            <div class="tcheck-event tcheck-event-main">
                <div class="tcheck-event-num">
                    #
                </div>
                <div class="tcheck-event-fix" v-if="hasFixedEvents">
                    {{$t('FIX')}}
                </div>
                <div class="tcheck-event-name">
                    {{$t('EVENT' + ((ticketData.data.selections.data[0].codeProduct != 'LOTTO') ? 'ANDMARKET' : ''))}}
                </div>
                <div class="tcheck-event-date">
                    {{$t('DATE')}}
                </div>
                <div class="tcheck-event-pick"
                v-if="ticketData.data.selections.data[0].codeProduct === 'SPORT'
                || ticketData.data.selections.data[0].codeProduct === 'OUTRIGHTS'
                || ticketData.data.selections.data[0].codeProduct === 'LOTTO_EXTENDED'">
                    {{$t('ODDNAME')}}
                </div>
                <div class="tcheck-event-pick"
                v-else-if="ticketData.data.selections.data[0].codeProduct === 'VHORSE'">
                    {{$t('HORSESSELECTED')}}
                </div>
                <!-- div class="tcheck-event-odd" v-if="ticketData.data.events[0].type === 'VHORSE'">
                    {{$t('SBVALUE')}}
                </div -->
                <!--div class="tcheck-event-odd" v-if="ticketData.data.events[0].type === 'SPORT'">
                    {{$t('SPECIFIERDATA')}}
                </div-->
                <div class="tcheck-event-odd"
                v-if="ticketData.data.selections.data[0].codeProduct === 'SPORT'
                || ticketData.data.selections.data[0].codeProduct === 'OUTRIGHTS'
                || ticketData.data.selections.data[0].codeProduct === 'VHORSE'
                || ticketData.data.selections.data[0].codeProduct === 'LOTTO_EXTENDED'">
                    {{$t('COEFF')}}
                </div>
                <div class="tcheck-event-status">
                    {{$t('STATUS')}}
                </div>
            </div>
            <vue-scroll class="tcheck-events-box" ref_testcafe="pickedMatchesBackend">
                <template v-if="ticketData.data.selections.data
                && ticketData.data.selections.data[0]
                && ticketData.data.selections.data[0].codeProduct === 'LOTTO'">
                    <div class="tcheck-event">
                        <div class="tcheck-event-num">
                            {{ticketData.data.selections.data[0].index !== undefined ? ticketData.data.selections.data[0].index + 1 : null}}
                        </div>
                        <div class="tcheck-event-name" ref_testcafe="lotto_name_on_accepted_slip">
                            {{ ticketData.data.selections.data[0].names['event-name'].texts[`${globals.langCode}`]}}
                        </div>
                        <div class="tcheck-event-date">
                            {{ticketData.data.selections.data[0].timestampEvent | getLocalDate}}
                        </div>
                        <div class="tcheck-event-status">
                            <div class="active" v-if="ticketData.data.status == 'ACTIVE'" >
                                <i class="icon-pending iconset"></i>
                            </div>
                            <div class="win" v-else-if="ticketData.data.status == 'WIN'">
                                <i class="icon-win iconset"></i>
                            </div>
                            <div class="lost" v-else-if="ticketData.data.status == 'LOST'">
                                <i class="icon-lost iconset"></i>
                            </div>
                            <div class="refund" v-else-if="ticketData.data.status == 'REFUND'">
                                <i class="icon-refund iconset"></i>
                            </div>
                            <div class="cancelled" v-else-if="ticketData.data.status == 'CANCELLED'">
                                <i class="icon-cancelled iconset"></i>
                            </div>
                            <div class="pending" v-else>
                                <i class="icon-pending iconset"></i>
                            </div>
                        </div>
                    </div>
                    <div class="tcheck-event-pick lotto-balls" ref_testcafe="slipSelectedNumbersContainer">
                        <div class="tcheck-event-numbers"
                        v-for="event in ticketData.data.selections.data"
                        :key="event.idOutcome">
                            <div class="loto-number-box">
                                <div class="loto-big-num small" :class="event.status.toLowerCase()">
                                    <div class="loto-ball-shadow"></div>
                                    <div class="loto-big-num-inner small">
                                        {{event.names['outcome-name'].texts[`${globals.langCode}`]}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="tcheck-event" ref_testcafe="backendSelectedMatches"
                    v-for="event in ticketData.data.selections.data"
                    :key="event.idEvent">
                        <div class="tcheck-event-num">
                            {{event.index !== undefined ? event.index + 1 : null}}
                        </div>
                        <div class="tcheck-event-fix" v-if="hasFixedEvents">
                            <i class="icon-fix iconset" v-if="event.fix"></i>
                        </div>
                        <div class="tcheck-event-name" v-if="event.codeProduct == 'OUTRIGHTS'">
                            <span>{{event.nameEvent[`${globals.langCode}`]}}</span>
                            <div class="market-name">{{event.names['outcomegroup-name'].texts[`${globals.langCode}`]}}</div>
                        </div>
                        <div class="tcheck-event-name" v-else-if="event.codeProduct == 'SPORT'">
                            {{event.names['t1-name'].texts[`${globals.langCode}`]}} - {{event.names['t2-name'].texts[`${globals.langCode}`]}}
                            <br>
                            <div class="market-name">
                                {{event.names['outcomegroup-name'].texts[`${globals.langCode}`] | formatSpecName(
                                    {teamNameOne: event.names['t1-name'].texts[`${globals.langCode}`],
                                    teamNameTwo: event.names['t2-name'].texts[`${globals.langCode}`]},
                                event.specifiers)}} <!--({{event.selectionGroupShortName}})-->
                                <span>
                                    <template v-if="event.attributes != null && event.attributes['has-modifier'] === '1'">
                                        <!-- TODO check this below after betslip fix -> event.names.modifier.texts[`${globals.langCode}`] -->
                                        ({{ getModifierName(event) }}: {{
                                            event.attributes['modifier-value'] | formatSpecName(
                                                {
                                                    teamNameOne: event.names['t1-name'].texts[`${globals.langCode}`],
                                                    teamNameTwo: event.names['t2-name'].texts[`${globals.langCode}`]
                                                },
                                                event.specifiers,
                                            )
                                        }})
                                    </template>
                                </span>
                            </div>
                        </div>
                        <div class="tcheck-event-name" v-else-if="event.codeProduct == 'LOTTO_EXTENDED'">
                            <span>{{event.nameEvent[`${globals.langCode}`]}}</span>
                            <div class="market-name">
                                {{$t(event.names['market-name'].texts[`${globals.langCode}`].toUpperCase()) | formatSpecName(undefined, event.specifiers) }}</div>
                        </div>
                        <div class="tcheck-event-name" v-else>
                            <span v-if="event.codeProduct === 'VHORSE'
                            && event.attributes
                            && event.attributes['daily-instance-id'] != null">
                                ({{event.attributes['daily-instance-id']}})
                                <span v-html="event.nameEvent[`${globals.langCode}`]"></span>
                            </span>
                            <template v-if="event.codeProduct === 'VHORSE'">
                                <br>
                                <div class="market-name">
                                    {{event.names['outcomegroup-name'].texts[`${globals.langCode}`]}}<span
                                    class="sbvalue" v-if="event.attributes['outcome-sbv']"> ({{event.attributes['outcome-sbv']}})
                                    </span>
                                </div>
                            </template>
                        </div>
                        <div class="tcheck-event-date tcheck-secondary-text">
                            <div v-if="event.eventStateInitial && event.eventStateInitial.state === 'live'" class="live">{{$t('LIVEEVENT')}}</div>
                            <div v-else >{{event.timestampEvent | getLocalDate}}</div>
                        </div>
                        <div class="tcheck-event-pick" v-if="event.codeProduct == 'SPORT'">
                            {{event.names['outcome-name'].texts[`${globals.langCode}`] | formatSpecName({teamNameOne: event.names['t1-name'].texts[`${globals.langCode}`],
                            teamNameTwo: event.names['t2-name'].texts[`${globals.langCode}`]},
                            event.specifiers)}} <!--({{event.selectionShortName}})-->
                        </div>
                        <div class="tcheck-event-pick" v-if="event.codeProduct == 'OUTRIGHTS'">
                            {{event.names['outcome-name'].texts[`${globals.langCode}`] | formatSpecName(null, event.specifiers)}}
                        </div>
                        <div class="tcheck-event-pick" v-if="event.codeProduct == 'LOTTO_EXTENDED'">
                            {{$t(event.names['outcome-name'].texts[`${globals.langCode}`].toUpperCase())}}
                        </div>
                        <div class="tcheck-event-pick" v-if="event.codeProduct == 'VHORSE'" ref_testcafe="vhorseOddBackend">
                            {{
                                event.names['outcome-name'].texts[`${globals.langCode}`] | formatSpecName(
                                    undefined,
                                    event.specifiers
                                )
                            }}
                        </div>
                        <!-- div class="tcheck-event-odd sbvalue" v-if="event.type === 'VHORSE'">
                            {{event.sbValue}}
                        </div -->
                        <div class="tcheck-event-odd"
                        v-if="event.codeProduct === 'SPORT'
                        || event.codeProduct === 'OUTRIGHTS'
                        || event.codeProduct === 'VHORSE'
                        || event.codeProduct === 'LOTTO_EXTENDED'">
                            <span :class="(event.status == 'HALFWIN'
                            || event.status == 'HALFLOST'
                            || event.status == 'REFUND') ? 'striked' : ''">
                                {{event.coeffEntry | formatOdd}}
                            </span>
                            <span class="odd-corrected"
                            v-if="event.status == 'HALFWIN'
                            || event.status == 'HALFLOST'
                            || event.status == 'REFUND'">
                                {{event.coeff | formatOdd}}
                            </span>
                        </div>
                        <div class="tcheck-event-status">
                            <div :class="(event.status == 'ACTIVE')
                            ? 'active'
                            : event.status.toLowerCase()" v-if="event.status == 'ACTIVE'" >
                                <i class="icon-pending iconset"></i>
                            </div>
                            <div :class="(event.status == 'WIN') ?
                            'win'
                            : event.status.toLowerCase()" v-else-if="event.status == 'WIN'">
                                <i class="icon-win iconset"></i>
                            </div>
                            <div :class="(event.status == 'LOST')
                            ?
                            'lost' : event.status.toLowerCase()" v-else-if="event.status == 'LOST'">
                                <i class="icon-lost iconset"></i>
                            </div>
                            <div :class="(event.status == 'REFUND') ? 'refund' : event.status.toLowerCase()" v-else>
                                <i class="icon-refund iconset"></i>
                            </div>
                        </div>
                    </div>
                </template>
            </vue-scroll>
            <template v-if="lottoResults && lottoResults.length">
                <div class="tcheck-info">
                    <div class="tcheck-status-box">
                        <div class="tcheck-total-stake">
                            {{$t('TICKETCHECK_DRAWNLOTTONUMBERS')}}
                        </div>
                    </div>
                </div>
                <div class="tcheck-event-pick lotto-balls">
                    <div class="tcheck-event-numbers"
                    v-for="event in lottoResults"
                    :key="event">
                        <div class="loto-number-box">
                            <div class="loto-big-num small">
                                <div class="loto-ball-shadow"></div>
                                <div class="loto-big-num-inner small">
                                    {{ event }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="tcheck-info">
                <div class="tcheck-status-box">
                    <div class="tcheck-total-stake">
                        {{$t('TOTALPAYIN')}}
                    </div>
                    <template
                    v-if="ticketData.data.payment.sumTotal
                    !== ticketData.data.payment.sumStake">
                        <div class="tcheck-total-stake">
                            {{$t('HANDLINGFEE')}}
                        </div>
                        <div class="tcheck-total-stake">
                            {{$t('TOTALSTAKE')}}
                        </div>
                    </template>
                    <div class="tcheck-bet-type" v-if="ticketData.data.calculationMeta.codeSystem !== 'NORMAL'">
                        {{$t('SYSTEMPLAYED')}}
                    </div>
                    <div class="tcheck-bet-type" v-if="ticketData.data.calculationMeta.codeSystem !== 'NORMAL'">
                        {{$t('COMBINATIONNUMBER')}}
                    </div>
                    <div class="tcheck-total-odd"
                    v-if="ticketDataCoefficient !== null">
                        {{$t('TOTALODD')}}
                    </div>
                    <div class="tcheck-bet-type">
                        {{(ticketData.data.status === 'ACTIVE')
                        ? $t('POTENTIALWIN')
                        : $t('TICKETWIN')}}
                    </div>
                    <div class="tcheck-poten-payout"
                    v-if="bonus.achieved"
                    >
                        <div v-if="ticketData.data.calculationMeta.codeSystem === 'NORMAL'">
                            {{(ticketData.data.status === 'ACTIVE')
                            ? $t('POTENTIALBONUS')
                            : $t('BONUS')}}</div>
                        <div v-else class="bonus-badge">{{$t('MAX_BONUS')}}</div>
                        <div v-if="bonus.percentage
                        && ticketData.data.calculationMeta.codeSystem === 'NORMAL'" class="bonus-badge">
                            {{bonus.percentage}}%
                        </div>
                    </div>
                    <div class="tcheck-bet-type">
                        {{$t('TICKETWINTAX')}}
                    </div>
                    <div class="tcheck-poten-payout" v-if="ticketDataPaidOut == false">
                        {{(ticketData.data.status === 'ACTIVE')
                        ? $t('POTENTIALPAYOUT')
                        : $t('TICKETPAYOUT')}}
                    </div>
                    <div class="tcheck-poten-payout" v-else>
                        {{$t('PAIDOUT')}}
                    </div>
                </div>
                <div class="tcheck-status-box tcheck-status-box-dark">
                    <div class="tcheck-total-stake no-upper">
                        {{ticketData.data.payment.sumTotal | formatNum}} {{ $getCurrencyAbbrv(paymentCurrency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="paymentCurrency === 'HRK'">
                                {{getEurValue(ticketData.data.payment.sumTotal, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(ticketData.data.payment.sumTotal) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div ref_testcafe="total_payin_backend" style="display: none">{{ticketData.data.payment.sumTotal}}</div>
                    <template
                    v-if="ticketData.data.payment.sumTotal
                    !== ticketData.data.payment.sumStake">
                        <div class="tcheck-total-stake no-upper" ref_testcafe="tax_backend_formatted">
                            {{ticketData.data.payment.sumHf | formatNum}} {{ $getCurrencyAbbrv(paymentCurrency) }}
                            <template v-if="calculateEurConversion">
                                <br>
                                <template v-if="paymentCurrency === 'HRK'">
                                    {{getEurValue(ticketData.data.payment.sumHf, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                </template>
                                <template v-else>
                                    {{getEurValue(ticketData.data.payment.sumHf) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                </template>
                            </template>
                        </div>
                        <div ref_testcafe="tax_backend" style="display: none">{{ticketData.data.payment.sumHf}}</div>
                        <div class="tcheck-total-stake no-upper">
                            {{ticketData.data.payment.sumStake | formatNum}} {{ $getCurrencyAbbrv(paymentCurrency) }}
                            <template v-if="calculateEurConversion">
                                <br>
                                <template v-if="paymentCurrency === 'HRK'">
                                    {{getEurValue(ticketData.data.payment.sumStake, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                </template>
                                <template v-else>
                                    {{getEurValue(ticketData.data.payment.sumStake) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                </template>
                            </template>
                        </div>
                        <div ref_testcafe="stake_backend" style="display: none">{{ticketData.data.payment.sumStake}}</div>
                    </template>
                    <div class="tcheck-bet-type no-upper" ref_testcafe="system_played_backend"
                    v-if="ticketData.data.calculationMeta.codeSystem !== 'NORMAL'">
                        {{systemType}}
                    </div>
                    <div class="tcheck-bet-type no-upper" ref_testcafe="number_of_combinations_backend"
                    v-if="ticketData.data.calculationMeta.codeSystem !== 'NORMAL'">
                        {{payoutDataCalculated.combinationCount}}
                    </div>
                    <div class="tcheck-total-odd" ref_testcafe="total_odd_backend_formatted"
                    v-if="ticketDataCoefficient !== null">
                        {{ticketDataCoefficient.sum | formatNum(4)}}
                    </div>
                    <div ref_testcafe="total_odd_backend" style="display: none">{{ticketDataCoefficient.sum}}</div>
                    <div class="tcheck-bet-type no-upper" ref_testcafe="potential_win_backend_formatted">
                        {{resolvedWinData.win.sum | formatNum}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="payoutCurrency === 'HRK'">
                                {{getEurValue(resolvedWinData.win.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(resolvedWinData.win.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div ref_testcafe="potential_win_backend" style="display: none">{{resolvedWinData.win.sum}}</div>
                    <div class="tcheck-poten-payout" v-if="bonus.achieved">
                        {{bonus.sum | formatNum(2)}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="payoutCurrency === 'HRK'">
                                {{getEurValue(bonus.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(bonus.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div class="tcheck-bet-type no-upper" ref_testcafe="win_tax_backend_formatted" v-if="ticketData.data.status === 'LOST'">
                        {{ 0 | formatNum(2)}} {{ $getCurrencyAbbrv(ticketData.data.payment.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="payoutCurrency === 'HRK'">
                                {{0 | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{0 | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div class="tcheck-bet-type no-upper" ref_testcafe="win_tax_backend_formatted" v-else>
                        {{resolvedWinData.taxOnPayout.sum | formatNum}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="payoutCurrency === 'HRK'">
                                {{getEurValue(resolvedWinData.taxOnPayout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(resolvedWinData.taxOnPayout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div ref_testcafe="win_tax_backend" style="display: none">{{resolvedWinData.taxOnPayout.sum}}</div>
                    <div class="tcheck-poten-payout no-upper"
                    v-if="ticketData.data.status === 'REFUND' && ticketData.data.paidOut === false">
                        {{resolvedWinData.payout.sum | formatNum}} {{$getCurrencyAbbrv(payoutCurrency)}}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="payoutCurrency === 'HRK'">
                                {{getEurValue(resolvedWinData.payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(resolvedWinData.payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div class="tcheck-poten-payout no-upper" v-else-if="ticketData.data.paidOut === true">
                        {{resolvedWinData.payout.sum | formatNum}} {{$getCurrencyAbbrv(payoutCurrency)}}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="payoutCurrency === 'HRK'">
                                {{getEurValue(resolvedWinData.payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(resolvedWinData.payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div class="tcheck-poten-payout no-upper" v-else-if="ticketData.data.payoutStatus === 'PAID'">
                        {{resolvedWinData.payout.sum | formatNum}} {{$getCurrencyAbbrv(payoutCurrency)}}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="payoutCurrency === 'HRK'">
                                {{getEurValue(resolvedWinData.payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(resolvedWinData.payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div class="tcheck-poten-payout no-upper" v-else-if="ticketData.data.status === 'LOST'">
                        {{resolvedWinData.payout.sum | formatNum}} {{$getCurrencyAbbrv(payoutCurrency)}}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="payoutCurrency === 'HRK'">
                                {{getEurValue(resolvedWinData.payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(resolvedWinData.payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div class="tcheck-poten-payout no-upper" v-else>
                        {{resolvedWinData.payout.sum | formatNum}} {{$getCurrencyAbbrv(payoutCurrency)}}
                        <template v-if="calculateEurConversion">
                            <br>
                            <template v-if="payoutCurrency === 'HRK'">
                                {{getEurValue(resolvedWinData.payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(resolvedWinData.payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    <p ref_testcafe="potential_payout_backend" style="display: none">{{payoutDataCalculated.payout.sum}}</p>
                    </div>
                    <!--div class="tcheck-poten-payout">
                        {{ticketData.data.sumBonus}}
                    </div-->
                    <!--div class="tcheck-poten-payout">
                        {{parseTicketBonus(ticketData.data.sumBonus)}}
                    </div-->
                </div>
                <div class="tcheck-status-box is-template"
                v-if="ticketData.data.tags.indexOf('template') !== -1">
                    <div class="tcheck-status">
                        {{$t('TICKETISTEMPLATE')}}
                    </div>
                </div>
                <div class="tcheck-status-box is-template"
                v-if="ticketData.data.tags.indexOf('test') !== -1">
                    <div class="tcheck-status">
                        {{ $t('TICKET_IS_TEST') }}
                    </div>
                </div>
                <div class="tcheck-status-box tcheck-status-box-dark ball-hits-container"
                v-if="ticketData.data.selections.data[0].codeProduct == 'LOTTO'
                && payoutDataCalculated.combinationCount
                && payoutDataCalculated.combinationCount > 1
                && winPerBalls !== false">
                    <div class="ball-hits-content" ref_testcafe="system_combinations_backend">
                        <div class="tcheck-ball-hits">
                            <div class="tcheck-ball-hits-sub"
                            v-for="(win, num) in winPerBalls"
                            :key="num">
                                <div class="tcheck-bet-type-ball">
                                    {{$t('GUESSEDNUMBERCOUNT', {num})}}:
                                </div>
                                <div class="tcheck-bet-type-ball">
                                    {{win.winTaxed
                                    | formatNum}} ({{win.win
                                    | formatNum}}) {{ $getCurrencyAbbrv(payoutCurrency) }}
                                    <template v-if="calculateEurConversion">
                                        <br>
                                        <template v-if="payoutCurrency === 'HRK'">
                                            {{getEurValue(win.winTaxed, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                        </template>
                                        <template v-else>
                                            {{getEurValue(win.winTaxed) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tcheck-status-box is-template"
                v-if="calculateEurConversion">
                    <div class="tcheck-status">
                        {{$t('EUR_FIXED_CONVERSION_RATE_NOTICE')}}
                    </div>
                </div>
                <div class="tcheck-status-box">
                    <div class="ticket-barcode">
                        <Barcode
                        v-if="displayBarcode"
                        :value="ticketData.data.code"
                        format="CODE128" :width="1.25" height="50" display-value="false">
                            Cannot render barcode
                        </Barcode>
                        <div v-if="globals.publicConfig.retailTicketAsDeposit === true
                            && ticketData.data.payment.channel.codeType === 'TERMINAL'
                            && ticketData.data.payoutStatus == 'UNPAID'
                            && ticketData.data.status === 'WIN'">
                            <div v-if="payoutStep == 1" >
                                <button class="button button-blue button-payout ml-md" v-on:click="startPayout">{{$t('PAYOUTTOONLINEACCOUNT')}}</button>
                            </div>

                            <div v-if="payoutStep == 2 && loading == false" class="d-flex ml-md">
                                <input class="input-text" type="text" v-model="controlCode" :placeholder="$t('CONTROLCODE')">
                                <button class="button button-blue button-payout ml-md" v-on:click="payouttoonl">{{$t('PAYOUTTOONLINEACCOUNT')}}</button>
                                <p class="error-text">{{depositError}}</p>
                            </div>
                            <div v-if="payoutStep == 2 && loading == true" class="loading-container">
                                <img src="../../assets/img/loading.svg">
                            </div>
                            <div v-if="payoutStep == 3" class="payout-success ml-lg">
                                <img src="../../assets/img/icon-payout-success.svg">
                                <p class="ml-sm">{{$t('FINISHEDPAYOUTTOONLINEACCOUNT')}}</p>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import moment from 'moment-timezone';
import Barcode from 'vue-barcode';
import { v4 as uuidv4 } from 'uuid';

export default {
    name: 'TicketModalDesktop',
    components:
    {
        Barcode,
    },
    data()
    {
        return {
            payoutStep: 1,
            controlCode: '',
            depositError: null,
            loading: false,
        };
    },
    methods:
    {
        ...mapActions([
            'payouttoonline',
        ]),
        getModifierName(item)
        {
            if (item.attributes
            && item.attributes['modifier-name']
            && item.attributes['modifier-name'][this.globals.langCode])
            {
                return item.attributes['modifier-name'][this.globals.langCode];
            }

            return '';
        },
        parseTicketBonus()
        {
            return '';
        },
        getUtcDate(date)
        {
            return moment.utc(date);
        },
        toggleTicketModal()
        {
            const me = this;
            me.$emit('toggleTicketModal');
        },
        getEurValue(val, reverse = false)
        {
            if (this.calculateEurConversion)
            {
                let eurCoeff = parseFloat(this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRate);

                if (reverse
                && this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRateReverse)
                {
                    eurCoeff = this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRateReverse;
                }

                return parseFloat(val) / eurCoeff;
            }

            return 0;
        },
        async payouttoonl()
        {
            const me = this;
            try
            {
                me.loading = true;
                me.depositError = null;
                const response = await me.payouttoonline({
                    uuid: uuidv4(),
                    codeControl: me.controlCode,
                    ticketCode: me.ticketData.data.code,
                    currency: me.usedCurrency,
                });

                if (response.error)
                {
                    me.depositError = me.$t(response.code.toUpperCase());
                    return;
                }

                me.payoutStep = 3;
            }
            catch (error)
            {
                me.depositError = error.code;
            }
            finally
            {
                me.loading = false;
            }
        },
        startPayout()
        {
            const me = this;

            me.payoutStep = 2;
        },
    },
    computed:
    {
        ...mapGetters([
            'isMobile',
            'ticketData',
            'globals',
            'playerdata',
            'usedCurrency',
        ]),
        paymentCurrency()
        {
            return this.ticketData.data.payment.currency;
        },
        payoutCurrency()
        {
            if (this.ticketData.data.payout)
            {
                return this.ticketData.data.payout.currency;
            }

            return this.ticketData.data.payment.currency;
        },
        resolvedWinData()
        {
            if (this.ticketData.data.payoutStatus === 'PAID'
            && this.ticketData.data.payout)
            {
                return {
                    win:
                    {
                        sum: this.ticketData.data.payout.sumWin,
                    },
                    payout:
                    {
                        sum: this.ticketData.data.payout.sumPayout,
                    },
                    taxOnPayout:
                    {
                        sum: this.ticketData.data.payout.sumTaxOnPayout,
                    },
                };
            }

            return this.payoutDataCalculated;
        },
        bonus()
        {
            const me = this;
            const ticket = me.ticketData.data;
            const payoutCalc = me.payoutDataCalculated;

            const bonus = {
                achieved: false,
                sum: null,
                percentage: null,
            };

            const sumBonus = (payoutCalc.bonus != null && payoutCalc.bonus.sum != null) ? payoutCalc.bonus.sum : 0;

            const bonusAmount = (ticket.payout != null
            && ticket.payout.bonus != null
            && ticket.payout.bonus.sum != null)
                ? ticket.payout.bonus.sum
                : sumBonus;
            // TODO bonus parsing
            if (payoutCalc.appliedBonuses
            && payoutCalc.appliedBonuses.length)
            {
                // achieved
                bonus.achieved = true;

                if (ticket.calculationMeta.codeSystem === 'NORMAL')
                {
                    const [appliedBonus] = payoutCalc.appliedBonuses;
                    bonus.percentage = appliedBonus.percentage;
                }
            }

            bonus.sum = bonusAmount;
            return bonus;
        },
        fixedEvents()
        {
            const me = this;
            const { selections, calculationMeta } = me.ticketData.data;
            let fixedEvents = 0;

            for (let j = 0; j < selections.data.length; j += 1)
            {
                if (calculationMeta.ticketGroup.members.indexOf(selections.data[j].index) !== -1)
                {
                    fixedEvents += 1;
                }
            }
            return fixedEvents;
        },
        systemType()
        {
            const me = this;
            let system;
            const { calculationMeta } = me.ticketData.data;
            if (calculationMeta !== undefined)
            {
                if (calculationMeta.codeSystem === 'SYSTEM')
                {
                    system = `${calculationMeta.ticketGroup.systems.join(';')}`
                        + `/${calculationMeta.countEvent}`;
                }
                else if (calculationMeta.codeSystem === 'FIX_SYSTEM')
                {
                    system = `${calculationMeta.resolveGroups[0].systems.join(';')}`
                        + `/${calculationMeta.countEvent - me.fixedEvents}`;
                }
            }
            return system;
        },
        combinationData()
        {
            const me = this;
            let combinationData;
            const { calculationMeta } = me.ticketData.data;
            if (calculationMeta !== undefined)
            {
                if (calculationMeta.codeSystem === 'SYSTEM')
                {
                    combinationData = {
                        selectedCombinations: calculationMeta.ticketGroup.systems,
                        total: calculationMeta.countEvent,
                    };
                }
                else if (calculationMeta.codeSystem === 'FIX_SYSTEM')
                {
                    combinationData = {
                        selectedCombinations: calculationMeta.resolveGroups[0].systems,
                        total: (calculationMeta.countEvent - me.fixedEvents),
                    };
                }
            }
            return combinationData;
        },
        payoutDataCalculated()
        {
            const me = this;
            const { status, resolveEstimate, resolve } = me.ticketData.data;

            let payoutCalc = resolveEstimate.calc;
            if (status === 'WIN'
            || status === 'LOST'
            || status === 'REFUND')
            {
                payoutCalc = resolve.calc;
            }

            return payoutCalc;
        },
        ticketDataDateRecieved()
        {
            const me = this;
            const { meta } = me.ticketData.data;

            if (meta.timestampSystem)
            {
                return meta.timestampSystem;
            }

            return meta.global.timestampSystem;
        },
        ticketType()
        {
            const me = this;

            const { selections } = me.ticketData.data;
            const type = selections.data[0].codeProduct;

            for (const event of selections.data)
            {
                if (type !== event.codeProduct)
                {
                    return 'MIX';
                }
            }

            return selections.data[0].codeProduct;
        },
        ticketDataCoefficient()
        {
            const me = this;

            const { resolve } = me.ticketData.data;
            if (resolve !== undefined
            && resolve.calc !== undefined
            && resolve.calc.coefficient !== undefined)
            {
                return resolve.calc.coefficient;
            }
            return null;
        },
        ticketDataPaidOut()
        {
            const me = this;
            let paidOut = false;

            if (me.ticketData.status === 'WIN'
            || me.ticketData.status === 'LOST'
            || me.ticketData.status === 'REFUND')
            {
                if (me.ticketData.payout !== undefined)
                {
                    paidOut = true;
                }
            }
            return paidOut;
        },
        ticketDataPayOffTaxAmount()
        {
            const me = this;
            const { payout, resolve } = me.ticketData.data;
            const payoutCalc = resolve.calc;
            // sum for win tax is returned even if ticket is lost - code  NYA9F4AX8W
            const tempSum = (payoutCalc.taxOnPayout.sum !== undefined) ? payoutCalc.taxOnPayout.sum : 0;

            if (payout !== undefined && payout.sumTaxOnPayout !== undefined)
            {
                return payout.sumTaxOnPayout;
            }

            return tempSum;
        },
        winPerBalls()
        {
            const me = this;
            let val = false;

            if (me.ticketData.data
            && me.ticketData.data.calculationMeta
            && me.ticketData.data.calculationMeta.lottoHitBallWins)
            {
                val = me.ticketData.data.calculationMeta.lottoHitBallWins;
            }
            return val;
        },
        hasFixedEvents()
        {
            const me = this;

            if (me.ticketData.data
            && me.ticketData.data.calculationMeta
            && me.ticketData.data.calculationMeta.codeSystem
            && me.ticketData.data.calculationMeta.codeSystem === 'FIX_SYSTEM')
            {
                for (const event of me.ticketData.data.selections.data)
                {
                    if (event.fix)
                    {
                        return true;
                    }
                }
            }
            return false;
        },
        calculateEurConversion()
        {
            return this.globals
                && this.globals.publicConfig
                && this.globals.publicConfig.hrkEurConversion
                && this.globals.publicConfig.hrkEurConversion.enabled;
        },
        lottoResults()
        {
            if (this.ticketType === 'LOTTO')
            {
                if (this.ticketData
                && this.ticketData.data
                && this.ticketData.data.selections
                && this.ticketData.data.selections.data
                && this.ticketData.data.selections.data.length)
                {
                    const [firstSelection] = this.ticketData.data.selections.data;

                    if (firstSelection.attributes
                    && firstSelection.attributes.results)
                    {
                        return firstSelection.attributes.results.split(',');
                    }
                }
            }

            return null;
        },
        displayBarcode()
        {
            if (this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.website
            && this.globals.publicConfig.website.displayBarcodeOnTicketModal != null)
            {
                return this.globals.publicConfig.website.displayBarcodeOnTicketModal;
            }

            return true;
        },
    },
};
</script>
